import * as React from "react";
import { Box, Typography } from "@mui/material";

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "transparent",
        padding: "15px",
        textAlign: "center",
        marginTop: "auto",
        position: "sticky",
        top: "100vh",
        width: "100%",
      }}
    >
      <Typography variant="body2" color="text.secondary">
        &copy; {new Date().getFullYear()} NNPC. All rights reserved.
      </Typography>
    </Box>
  );
}

export default Footer;
